export default function (data) {
  return data.amenities?.includes('Luxury')
}
